import { Injectable } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { environment } from 'environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthUserService {
  private userId: string = '';
  private isTempProfile: boolean;
  docRef: any = document;
  winRef: any = window;
  enviRef: any = environment;
  private user: any;

  constructor(private router: Router) {}

  public isLoggedIn(): boolean {
    return Cookie.check('SESSION');
  }

  public cleanUpLeftoverCookies(): void {
    if (!Cookie.check('SESSION')) {
      Cookie.delete('iPlanetDirectoryPro');
      Cookie.delete('IAMSession');
    }
  }

  public clearSessionCookie(): void {
    Cookie.delete('SESSION');
  }

  public signInUser(calledFromSecurityModal = false, lastVisitedRoute = ''): void {
    if (calledFromSecurityModal) {
      // delete in case value is persisting from previous session, this will get reset
      let path = '';
      // This is done for localhost:4200 developmenet only
      if (!this.enviRef.production && this.winRef.location.port !== '8080') {
        path = this.enviRef.LOCAL_DEV_GATEWAY_URL;
      }
      this.redirectAssign(`${path}/openid_connect_login`);
    } else {
      // We are saving the last visited route here so that the different
      // auth guards in the system don't have to manage this themselves
      // Only necessary when an Auth Guard is calling signInUser()
      if (lastVisitedRoute !== '') {
        lastVisitedRoute = this.redirectReplace('/auth-terms-disclosure', '');
        const isIE = !!this.docRef['documentMode'] || false;
        if (isIE) {
          this.winRef.localStorage.setItem('lastVisitedRoute', lastVisitedRoute + '|sfe3');
          this.winRef.localStorage.setItem('lastVisitedRouteFromChild', lastVisitedRoute);
        } else {
          this.winRef.sessionStorage.setItem('lastVisitedRoute', lastVisitedRoute + '|sfe3');
          this.winRef.sessionStorage.setItem('lastVisitedRouteFromChild', lastVisitedRoute);
        }
      }
      this.router.navigate(['/auth-terms-disclosure']);
    }
  }

  public redirectAssign(url) {
    this.winRef.location.assign(url);
  }
  public redirectReplace(path, other = '') {
    return this.winRef.location.pathname.replace(path, other);
  }

  public newProfileForLoginID(): void {
    let path = '';
    // For localhost:4200 development only
    if (!this.enviRef.production && this.winRef.location.port !== '8080') {
      path = this.enviRef.LOCAL_DEV_GATEWAY_URL;
    }
    this.redirectAssign(`${path}/auth/postauth?createNewProfile=true`);
  }

  public deleteOldProfile(): void {
    let path = '';
    // For localhost:4200 development only
    if (!this.enviRef.production && this.winRef.location.port !== '8080') {
      path = this.enviRef.LOCAL_DEV_GATEWAY_URL;
    }
    this.redirectAssign(`${path}/auth/postauth?deleteOldProfile=true`);
  }

  public riscProfileRecovery(type: string): void {
    let path = '';
    // For localhost:4200 development only
    if (!this.enviRef.production && this.winRef.location.port !== '8080') {
      path = this.enviRef.LOCAL_DEV_GATEWAY_URL;
    }
    this.redirectAssign(`${path}/auth/postauth?profileRecovery=${type}`);
  }

  public signInUserIAL2(): void {
    // delete in case value is persisting from previous session, this will get reset
    Cookie.delete('OPP_FRONTEND_ACCESS');
    Cookie.delete('SESSION');
    Cookie.delete('XSRF-TOKEN');
    let path = '';
    // This is done for localhost:4200 developmenet only
    if (!this.enviRef.production && this.winRef.location.port !== '8080') {
      path = this.enviRef.LOCAL_DEV_GATEWAY_URL;
    }
    this.redirectAssign(`${path}/identity-proof`);
  }

  public signOutUser(): void {
    let path = '';
    Cookie.delete('OPP_FRONTEND_ACCESS');
    // This is done for localhost:4200 development only
    if (!this.enviRef.production && this.winRef.location.port !== '8080') {
      this.clearSessionCookie();
      path = this.enviRef.LOCAL_DEV_GATEWAY_URL;
    }
    this.user = null;
    this.redirectAssign(`${path}/signout`);
  }

  public getAuthToken(): string {
    if (Cookie.check('SESSION')) {
      return Cookie.get('SESSION');
    }
    return '';
  }

  public setUserId(userId: string): void {
    this.userId = userId;
  }

  public getLoggedInUserId(): string {
    return this.userId;
  }

  public setIsTempProfile(isTempProfile: boolean): void {
    this.isTempProfile = isTempProfile;
  }

  public getIsTempProfile(): boolean {
    return this.isTempProfile;
  }

  public setOppFrontEndAccess(value: boolean) {
    Cookie.set('OPP_FRONTEND_ACCESS', value.toString());
  }

  public getOppFrontEndAccess() {
    return Cookie.get('OPP_FRONTEND_ACCESS') === 'true' ? true : false;
  }

  public checkOppFrontEndAccessCookie() {
    return Cookie.check('OPP_FRONTEND_ACCESS');
  }

  public setUser(user: any) {
    this.user = user;
  }

  public getUser() {
    return this.user;
  }
}
